import { readJsonCookie, writeJsonCookie } from '../../utils/jsonCookie'
import type { PeriodPreset } from './periodParams'

export type StatusFilter = 'all' | 'in_progress' | 'complete' | 'with_logged_time'

export interface StatisticsFilters {
    status: StatusFilter
    period: PeriodPreset
    customStart: string
    customEnd: string
}

export const STATUS_OPTIONS: {id: StatusFilter; title: string}[] = [
    {id: 'all', title: 'Все задачи'},
    {id: 'in_progress', title: 'Задачи в процессе'},
    {id: 'complete', title: 'Завершённые задачи'},
    {id: 'with_logged_time', title: 'З залогованим часом'},
]

export const PERIOD_OPTIONS: {id: PeriodPreset; title: string}[] = [
    {id: 'week', title: 'Неделя'},
    {id: 'month', title: 'Месяц'},
    {id: 'quarter', title: 'Квартал'},
    {id: 'year', title: 'Год'},
    {id: 'custom', title: 'Период'},
]

const STATUS_VALUES = STATUS_OPTIONS.map(({ id }) => id)
const PERIOD_VALUES = PERIOD_OPTIONS.map(({ id }) => id)
const DATE_RE = /^\d{4}-\d{2}-\d{2}$/

const STATISTICS_FILTERS_COOKIE_NAME = 'statistics-filters'

export function getDefaultStatisticsFilters(): StatisticsFilters {
    return {
        status: 'all',
        period: 'month',
        customStart: '',
        customEnd: '',
    }
}

const readDate = (value: unknown) => (typeof value === 'string' && DATE_RE.test(value) ? value : '')

export function readStatisticsFilters(): StatisticsFilters {
    const defaultFilters = getDefaultStatisticsFilters()
    const parsedValue = readJsonCookie(STATISTICS_FILTERS_COOKIE_NAME)

    if (!parsedValue) {
        return defaultFilters
    }

    return {
        status: STATUS_VALUES.includes(parsedValue.status) ? parsedValue.status : defaultFilters.status,
        period: PERIOD_VALUES.includes(parsedValue.period) ? parsedValue.period : defaultFilters.period,
        customStart: readDate(parsedValue.customStart),
        customEnd: readDate(parsedValue.customEnd),
    }
}

export function writeStatisticsFilters(filters: StatisticsFilters) {
    writeJsonCookie(STATISTICS_FILTERS_COOKIE_NAME, filters, 'statistics filters')
}
